// import { stringify } from 'querystring'
import React, { FC, useState } from 'react'
import styled from 'styled-components'
// import { ToggleSwitch } from 'components/ToggleSwitch/ToggleSwitch'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/loader.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'

export const FilterComponent: FC<{
  textBlocks: string[][]
  labelsKiToggle: string[]
  titleTextSection?: string
  titleStyleSection?: string
  titleToggleSection?: string
  colorMode?: string
}> = ({
  textBlocks,
  titleTextSection,
  titleToggleSection,
  titleStyleSection,
  labelsKiToggle,
  colorMode,
}) => {
  // console.log(textBlocks)
  const [indexTextSentence, setIndexTextSentence] = useState(
    textBlocks.map((defaultIndex: string[], defaultIndexKey: number) => {
      return 0
    })
  )
  //   console.log('defaultIndex', indexTextSentence)

  /* Alte statische Lösung */
  //   const [elementTextSentence, setElementTextSentence] = useState([
  //     textBlocks[0][0],
  //     textBlocks?.[1]?.[0],
  //     textBlocks?.[2]?.[0],
  //   ])

  const [elementTextSentence, setElementTextSentence] = useState(
    textBlocks.map((defaultText: string[], defaultTextKey: number) => {
      return defaultText[0]
    })
  )

  const [labelKiToggle, setLabelKiToggle] = useState(
    labelsKiToggle.map((defaultText: string, defaultTextKey: number) => {
      return defaultText
    })
  )

  const [loading, setLoadingStatus] = useState(false)
  const [ki, setKi] = useState(labelKiToggle[0])

  //show default/error image if link is broken
  const addDefaultSrc = (): any => {
    try {
      return ki === labelKiToggle[0]
        ? require(`../Assets/dalle/${indexTextSentence
            .toString()
            .replaceAll(',', '-')}.jpg`)
        : require(`../Assets/stableDiffusion/${indexTextSentence
            .toString()
            .replaceAll(',', '-')}.jpg`)
    } catch {
      if (colorMode === 'light') {
        return require(`../Assets/error.png`)
      } else {
        return require(`../Assets/error-dark.png`)
      }
    }
  }

  return (
    <>
      <ImageComponentWrapper>
        <PlaceholderText className={colorMode === 'dark' ? 'dark' : ''}>
          <div className='right-arrow'></div>
          <Title>{titleTextSection}</Title>
          {textBlocks &&
            textBlocks.map((textBlock: string[], textBlockKey: number) => {
              const checkIndexTwo = textBlockKey === 2
              return (
                <>
                  {checkIndexTwo && <Title>{titleStyleSection}</Title>}
                  <TextBlock key={textBlockKey}>
                    {textBlock?.map((element: string, key: number) => {
                      return (
                        // <button
                        //   disabled={indexTextSentence[textBlockKey] === key}
                        //   type='button'
                        //   key={key}
                        //   onClick={(event) => {
                        //     // console.log(indexTextSentence)
                        //     const copy = indexTextSentence.slice()
                        //     copy[textBlockKey] = key
                        //     setIndexTextSentence(copy)
                        //     // console.log(copy)

                        //     // console.log(elementTextSentence)
                        //     const copyElement = elementTextSentence.slice()
                        //     copyElement[textBlockKey] = element
                        //     setElementTextSentence(copyElement)
                        //     // console.log(copyElement)

                        //     if (!loading) {
                        //       setLoadingStatus(true)
                        //     }
                        //     // console.log('loading', loading)
                        //   }}
                        // >
                        //   {element}
                        // </button>
                        <>
                          <span
                            key={key}
                            onClick={(event: any) => {
                              if (elementTextSentence.includes(element)) {
                                return
                              }
                              // console.log(indexTextSentence)
                              const copy = indexTextSentence.slice()
                              copy[textBlockKey] = key
                              setIndexTextSentence(copy)
                              // console.log(copy)

                              // console.log(elementTextSentence)
                              const copyElement = elementTextSentence.slice()
                              copyElement[textBlockKey] = element
                              setElementTextSentence(copyElement)

                              if (!loading) {
                                setLoadingStatus(true)
                              }
                            }}
                            className={
                              elementTextSentence.includes(element)
                                ? 'active'
                                : ''
                            }
                          >
                            {element}
                          </span>
                          <span>&ensp;&ensp;</span>
                        </>
                      )
                    })}
                  </TextBlock>
                </>
              )
            })}
          <Title className='toggleTitle'>{titleToggleSection}</Title>
          <PlaceholderToggle>
            <Label>
              {labelKiToggle?.map((element: string, key: number) => {
                return (
                  <React.Fragment key={key}>
                    <span
                      onClick={(event: any) => {
                        setKi(element)
                        if (!loading) {
                          setLoadingStatus(true)
                        }
                      }}
                      className={ki === element ? 'active' : ''}
                    >
                      {element}
                    </span>
                    <span>&ensp;&ensp;</span>
                  </React.Fragment>
                )
              })}
            </Label>
          </PlaceholderToggle>
        </PlaceholderText>

        <PlaceholderImage>
          <div
            className={
              'ui vertical ' +
              (loading ? 'loading ' : '') +
              'segment dimmerWrapper'
            }
          >
            {/* <div className={'ui text loader'}>Bild wird geladen...</div> */}
            {loading && (
              <div className={'ui active inverted dimmer'}>
                <div className={'ui text loader'} style={{ color: '#202346' }}>
                  Bild wird geladen...
                </div>
              </div>
            )}

            <img
              src={addDefaultSrc()}
              onLoad={() => {
                // Just to simulate a slow network:
                setTimeout(() => {
                  setLoadingStatus(false)
                }, 300 + Math.random() * 80)
                // console.log('loaded')
              }}
              className={loading ? 'loadingImage' : ''}
              key={elementTextSentence.toString()}
              alt={`${elementTextSentence.slice(0, -1)
                .toString()
                .replaceAll(',', ' ').replaceAll('.', '')} im Stil ${elementTextSentence.slice(-1)
                  .toString()}. Bild: KI (${ki})`}
            ></img>
          </div>
        </PlaceholderImage>
      </ImageComponentWrapper>
    </>
  )
}

const ImageComponentWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
margin-bottom: 60px;
  @media only screen and (min-width: 1024px) {
    > :nth-child(odd) {
      margin-right: 1em;
    }
    > :nth-child(even) {
      margin-left: 1em;
    }
  }
  @media only screen and (max-width: 1023px) {
    flex-direction: column;
  }
`

const PlaceholderText = styled.div`
  flex: 1;
  font-size: 1.8rem;
  position: relative;
  /* font-family: var(--font-sans-serif); */
  background: var(--brandblue-bright-5);
  /* box-shadow: rgb(0 0 0 / 5%) 0px 10px 20px; */
  border-radius: 10px;
  padding: 1em;
  /* margin: 1em 0px;
  margin-bottom: 2em; */
  &.dark {
    background: var(--brandblue-bright-1);
    .right-arrow {
      border-bottom: 20px solid var(--brandblue-bright-1);
    }
  }

  @media only screen and (max-width: 1023px) {
    margin-bottom: 1.5em;
  }

  @media only screen and (min-width: 1024px) {
    .right-arrow {
      position: absolute;
      width: 0;
      height: 0;
      border-left: 20px solid transparent;
      border-right: 20px solid transparent;

      border-bottom: 20px solid var(--brandblue-bright-5);
      transform: rotate(90deg);
      top: calc(50% - 20px);
      right: -1.4em;

      /* margin: 2rem; */
    }
  }
  @media only screen and (max-width: 1023px) {
    .right-arrow {
      position: absolute;
      width: 0;
      height: 0;
      border-left: 20px solid transparent;
      border-right: 20px solid transparent;

      border-bottom: 20px solid var(--brandblue-bright-5);
      transform: rotate(180deg);
      bottom: -0.75em;
      right: calc(50% - 20px);
      z-index: 100;
    }
  }
`

const Title = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 1.4rem;
  line-height: 2rem;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
  /* &.toggleTitle {
    text-align: center;
  } */
  @media only screen and (max-width: 599px) {
    font-size: 1.2rem;
    line-height: 1.8rem;
  }
`

const TextBlock = styled.div`
  font-size: 1.8rem;
  margin-bottom: 2rem;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  line-height: 3rem;
  @media only screen and (max-width: 599px) {
    margin-bottom: 1.5rem;
    line-height: 2.5rem;
  }

  :last-of-type {
    margin: 0;
  }
  span {
    font-size: 2rem;
    font-family: var(--font-sans-serif);
    color: var(--text-color);
    /* background-color: transparent;
    border: none; */
    font-weight: 400;
    opacity: 0.4;
    cursor: pointer;
    display: inline;
    -webkit-tap-highlight-color: transparent;
    :first-of-type {
      white-space: nowrap;
    }
    @media only screen and (max-width: 599px) {
      font-size: 1em;
      line-height: 1rem;
    }
  }

  span.active {
    background-color: transparent;
    border: none;
    color: var(--brandblue-bright-main);
    opacity: 1;
    /* border: 1px solid; */
    /* border-radius: 20px; */
  }
  span:hover {
    color: var(--brandblue-bright-main);
    opacity: 1;
  }
`
const Label = styled.div`
  font-size: 1.8rem;
  margin-bottom: 2rem;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  line-height: 3rem;
  @media only screen and (max-width: 599px) {
    margin-bottom: 1.5rem;
    line-height: 2.5rem;
  }

  :last-of-type {
    margin: 0;
  }
  span {
    font-size: 2rem;
    font-family: var(--font-sans-serif);
    color: var(--text-color);
    /* background-color: transparent;
    border: none; */
    font-weight: 400;
    opacity: 0.4;
    cursor: pointer;
    display: inline;
    -webkit-tap-highlight-color: transparent;
    :first-of-type {
      white-space: nowrap;
    }
    @media only screen and (max-width: 599px) {
      font-size: 1em;
      line-height: 1rem;
    }
  }

  span.active {
    background-color: transparent;
    border: none;
    color: var(--brandblue-bright-main);
    opacity: 1;
    /* border: 1px solid; */
    /* border-radius: 20px; */
  }
  span:hover {
    color: var(--brandblue-bright-main);
    opacity: 1;
  }
`
const PlaceholderImage = styled.div`
  flex: 1;
  font-family: var(--font-serif);
  font-size: 1.8rem;
  /* line-height: 3rem; */

  .ui.vertical.loading.segment.dimmerWrapper::after {
    display: none;
  }

  .ui.vertical.loading.segment.dimmerWrapper,
  .ui.vertical.segment.dimmerWrapper {
    padding: 0;
    padding-bottom: 100%;
    background: var(--gray-4);
    height: 0;
    position: relative;
    overflow: hidden;
  }

  img {
    width: 100%;
    background-color: var(--gray-4);
    height: 100%;
    display: block;
    position: absolute;
    z-index: 0;
  }
  img.loadingImage {
    animation: loadingImage 0.4s;
    /* margin: -5px 0 0 -5px; */
    @keyframes loadingImage {
      0% {
        /* filter: blur(20px); */
        opacity: 0;
      }
      30% {
        /* filter: blur(20px); */
        opacity: 0;
      }
      50% {
        opacity: 0.2;
        /* filter: blur(10px); */
      }
      100% {
        opacity: 0.8;
        /* filter: blur(0px); */
      }
    }
  }
`
const PlaceholderToggle = styled.div``

